import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const UpdateParticipant = () => {
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [age, setAge] = useState("");
  const [sex, setSex] = useState("");

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axiosPrivate.post("/participate/updatedetails", {
        name,
        phone,
        age,
        sex,
        encryptedQuizId: localStorage.getItem("quizid"),
        encryptedParticipantEmail: localStorage.getItem("participantEmail"),
      });

      if (response.data.message) {
        setSuccess(response.data.message);
        setError("");
        setName("");
        setPhone("");
        setAge("");
        setSex("");

        // Redirect after short delay
        setTimeout(() => {
          navigate("/quiz/start");
        }, 1500);
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        setError(err.response.data.message);
        setSuccess("");
      } else {
        setError("Something went wrong. Please try again.");
        setSuccess("");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fade-in" style={{ maxWidth: "600px", margin: "0 auto", padding: "2rem 1rem" }}>
      <div style={{ marginBottom: "2rem", textAlign: "center" }}>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            marginBottom: "0.5rem",
            background: "linear-gradient(135deg, var(--primary-purple-light), var(--accent-cyan))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Update Details
        </h1>
        <p style={{ color: "var(--text-muted)", fontSize: "1.125rem" }}>
          Please complete your profile to continue
        </p>
      </div>

      <div className="card" style={{ padding: "2.5rem" }}>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="John Doe"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="+1234567890"
              required
            />
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
            <div className="form-group">
              <label htmlFor="age">Age</label>
              <input
                type="number"
                id="age"
                value={age}
                onChange={(e) => setAge(e.target.value)}
                placeholder="25"
                required
                min="1"
                max="120"
              />
            </div>

            <div className="form-group">
              <label htmlFor="sex">Gender</label>
              <select
                id="sex"
                value={sex}
                onChange={(e) => setSex(e.target.value)}
                required
                style={{
                  appearance: "none",
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23CBD5E1' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 1rem center",
                  paddingRight: "3rem"
                }}
              >
                <option value="">Select...</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <button
            type="submit"
            className="btn-primary"
            style={{ width: "100%", marginTop: "1rem" }}
            disabled={loading}
          >
            {loading ? "Updating..." : "Update & Continue"}
          </button>
        </form>

        {error && <p className="errmsg" style={{ marginTop: "1.5rem" }}>{error}</p>}
        {success && (
          <div className="successmsg" style={{ marginTop: "1.5rem", textAlign: "center" }}>
            <p>✓ {success}</p>
            <p style={{ fontSize: "0.875rem", marginTop: "0.5rem" }}>Redirecting to quiz...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpdateParticipant;
